// index.js in the 'src' directory
import { Buffer } from "buffer";
import process from "process";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import {store } from './helpers/store';
import App from './App/App';
import './index.css';

window.Buffer = Buffer;
window.process = process;
// Get the root element from your HTML
const rootElement = document.getElementById('root');

// Create a root
const root = createRoot(rootElement);

// Render your app using the root.render method
root.render(
    <Provider store={store}>
      <App />
    </Provider>
);